import { Component } from '@angular/core';

@Component({
  selector: 'app-hatch-skin',
  templateUrl: './hatch-skin.component.html',
  styleUrls: ['./hatch-skin.component.scss'],
})
export class HatchSkinComponent {}
